module.exports = __webpack_public_path__ + "img/quarter-user@2x.fc4fb29d.png";